<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card variant="flat" elevation="0">
          <v-card-text class="text-center pt-6 pb-0">
            <v-img
                :src="bigLogo"
                max-width="300"
                class="mx-auto mb-0"
                contain
            />
          </v-card-text>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="email"
                :label="$t('login.email')"
                type="email"
                required
                outlined
              />
              <v-text-field
                v-model="password"
                :label="$t('login.password')"
                type="password"
                required
                outlined
              />
              <v-btn type="submit" color="primary" block>{{ $t('login.loginButton') }}</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import bigLogo from '../assets/big_logo.jpg'

const { t } = useI18n()

const router = useRouter()
const email = ref('')
const password = ref('')

const login = async () => {
  try {
    // Log the full URL being used
    const apiUrl = '/api/users/sign_in'

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user: {
          email: email.value,
          password: password.value,
        },
      }),
      redirect: 'follow', // Explicitly follow redirects
    })
    
    if (response.ok) {
      const data = await response.json()
      if (data.token) {
        localStorage.setItem('auth_token', data.token)
        // Trigger custom event to update App.vue auth state
        window.dispatchEvent(new CustomEvent('auth-changed'))
        router.push('/')
      }
    } else {
      // Try to get error message from response
      let errorMessage = t('login.loginFailed')
      try {
        const errorData = await response.json()
        errorMessage = errorData.error || errorMessage
      } catch (e) {
        // If response is not JSON, use status text
        errorMessage = `${errorMessage} (${response.status}: ${response.statusText})`
      }
      console.error('Login failed:', response.status, errorMessage)
    }
  } catch (error) {
    console.error('Login error:', error)
    // Show more detailed error message
    const errorMsg = error instanceof Error ? error.message : String(error)
    
    // Check for network errors
    if (error instanceof TypeError && error.message.includes('fetch')) {
      console.error('Network error - possible causes:')
      console.error('1. Server not accessible at:', window.location.origin)
      console.error('2. CORS issue')
      console.error('3. Connection refused')
      alert(t('login.loginError') + ': Network error - Check browser console for details')
    } else {
      alert(t('login.loginError') + ': ' + errorMsg)
    }
  }
}
</script>

